module.exports = __webpack_public_path__ + "img/person-avatar.d36da681.png";